const fakeDataForTravelSpot = [
    {
        id: 0,
        title: "SAJEK",
        info: "Sajek valley is known for its natural environment and is surrounded by mountains, dense forest, and grassland hill tracks. Many small rivers flow through the mountains among which the Kachalong and the Machalong are notable.",
        position: [50.28,12.91],
        hotel: [{location: [50.28,12.91]},{location: [50.27,12.98]},{location: [50.28,12.95]},{location: [50.28,12.88]}]
    
    },
    {
        id: 1,
        title: "SREEMANGAL",
        info: `Sreemangal is a hilly area covered with tea estates. There are 47 tea gardens in Sreemangal. A large portion of world’s highest quality tea is grown here. It is also called the city of ‘two leaves and a bud. Sreemangal is famous for nature,
        forests and wildlife.`,
        position: [24.31,91.72],
        hotel: [{location: [24.33,91.72]},{location: [24.31,91.68]},{location: [24.29,91.75]},{location: [24.33,91.70]}]
    },
    {
        id: 2,
        title: "SNDARBAN",
        info: "The Sundarbans is a mangrove area in the delta formed by the confluence of the Ganges, Brahmaputra and Meghna Rivers in the Bay of Bengal. It spans from the Hooghly River in India's state of West Bengal to the Baleswar River in Bangladesh.",
        position: [22.00,88.67],
        hotel: [{location: [21.97,88.67]},{location: [22.00,88.70]},{location: [22.00,88.60]},{location: [21.98,88.72]}]

    }
]
export default fakeDataForTravelSpot;